module.exports = __webpack_public_path__ + "img/1512601048.27dcdd2d.jpg";